module.exports = __webpack_public_path__ + "static/img/smm-img.04f1b8b6.png";